import { defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import useTransactionsStore from '@/store/modules/transactions';
export default defineComponent({
    name: 'EFTDepositComponent',
    emits: ['closeIframe'],
    setup(_, { emit }) {
        const transactionsStore = useTransactionsStore();
        const { collection } = storeToRefs(transactionsStore);
        window.addEventListener('message', event => {
            if (event.origin === process.env.VUE_APP_PAYMENT_REDIRECT_URL) {
                setTimeout(() => {
                    emit('closeIframe');
                }, 1000);
            }
        });
        return {
            collection,
        };
    },
});
